<template>
  <div
    :class="[
      'table-section',
      `${sectionType}-section`,
      'section-styles',
      'column-widths',
      'responsive-table',
    ]"
  >
    <table class="custom-table">
      <colgroup>
        <col v-for="index in 7" :key="index" :class="`col-${index}`" />
      </colgroup>
      <tbody>
        <tr
          v-for="(row, rowIndex) in rows"
          :key="`${sectionType}-${rowIndex}`"
          :class="getRowClass(row, rowIndex)"
        >
          <td
            v-for="(cell, cellIndex) in row.cells"
            :key="cellIndex"
            :rowspan="cell.rowspan"
            :colspan="cell.colspan"
            :class="getCellClass(cell)"
          >
            <cell-renderer
              :cell="cell"
              :row-index="getActualRowIndex(rowIndex)"
              :preview-mode="previewMode"
              @checkbox-change="handleCellCheckboxChange"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CellRenderer from "./CellRenderer.vue";
import "./styles/table-styles.scss";

export default {
  name: "TableSection",
  components: {
    CellRenderer,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    colCount: {
      type: Number,
      default: 7,
    },
    sectionType: {
      type: String,
      default: "middle",
      validator: (value) => ["top", "middle", "bottom"].includes(value),
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getRowClass(row, rowIndex) {
      const classes = [];
      if (row.className) classes.push(row.className);
      if (row.isDeep) classes.push("deepRow");
      classes.push("font-styles");
      return classes;
    },

    getCellClass(cell) {
      const classes = ["cell-styles"];
      if (cell.className) classes.push(cell.className);
      if (cell.type === "checkbox")
        classes.push("checkbox-cell checkbox-styles");
      if (cell.isBold) classes.push("bold-text");
      if (cell.isLarger) classes.push("larger-text");
      return classes;
    },

    getActualRowIndex(rowIndex) {
      const sectionOffsets = {
        top: 0,
        middle: 3,
        bottom: 8,
      };
      return sectionOffsets[this.sectionType] + rowIndex;
    },

    handleCellCheckboxChange(payload) {
      this.$emit("checkbox-change", payload);
    },
  },
};
</script>

<style scoped>
/* 表格区域样式 */
.table-section {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialRangeComponents/TableSection.vue